import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex justify-center" }
const _hoisted_2 = { class: "w-11/12 pb-4" }
const _hoisted_3 = { class: "p-4" }
const _hoisted_4 = { class: "flex justify-between my-1" }
const _hoisted_5 = { class: "break-words whitespace-pre-wrap w-9/12" }
const _hoisted_6 = { class: "p-4" }
const _hoisted_7 = { class: "flex justify-between my-1" }
const _hoisted_8 = { class: "break-words whitespace-pre-wrap w-9/12" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_select = _resolveComponent("v-select")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_v_select, {
          modelValue: _ctx.selectedStore,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.selectedStore) = $event)),
          class: "bg-white",
          placeholder: "購入店舗",
          options: _ctx.stores,
          searchable: false,
          label: "name"
        }, {
          option: _withCtx((store) => [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, _toDisplayString((store as PurchaseStore).name), 1)
            ])
          ]),
          _: 1
        }, 8, ["modelValue", "options"])
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createVNode(_component_v_select, {
          modelValue: _ctx.selectedItem,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.selectedItem) = $event)),
          class: "bg-white",
          placeholder: "購入商品",
          options: _ctx.displayItems,
          searchable: false,
          label: "name",
          uid: "item_type"
        }, {
          option: _withCtx((item) => [
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("div", _hoisted_8, _toDisplayString((item as Item).name), 1)
            ])
          ]),
          _: 1
        }, 8, ["modelValue", "options"])
      ])
    ])
  ]))
}